import React, { Fragment } from "react";
import { Dialog, Transition, TransitionChild } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import ProcessWheelForm, {
  ProcessWheelFormValues,
} from "../ProcessWheelForm/ProcessWheelForm";
import { ProcessWheel } from "../../api/getProcessWheels/types";

interface EditProcessWheelDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  processWheel: ProcessWheel;
  onSubmit: (values: ProcessWheelFormValues) => void;
  loading?: boolean;
}

const EditProcessWheelDrawer: React.FC<EditProcessWheelDrawerProps> = ({
  isOpen,
  onClose,
  processWheel,
  onSubmit,
  loading = false,
}) => {
  return (
    <Transition as={Fragment} show={isOpen}>
      <Dialog as="div" className="relative z-40" onClose={onClose}>
        <TransitionChild
          as={Fragment}
          enter="transition-opacity ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-30" />
        </TransitionChild>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
              <TransitionChild
                as={Fragment}
                enter="transform transition ease-in-out duration-300"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-300"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                  <div className="flex h-full flex-col bg-white dark:bg-slate-900 shadow-xl">
                    <div className="flex items-center justify-between px-4 py-4 bg-primary">
                      <Dialog.Title className="text-lg font-medium text-white">
                        Edit Process Wheel
                      </Dialog.Title>
                      <button
                        className="text-white"
                        onClick={onClose}
                        type="button"
                      >
                        <XMarkIcon className="h-6 w-6" />
                      </button>
                    </div>

                    <div className="flex-1 overflow-y-auto px-4 py-4 sm:px-6">
                      <ProcessWheelForm
                        initialData={{
                          name: processWheel.name,
                          description: processWheel.description ?? "",
                        }}
                        loading={loading}
                        onSubmit={onSubmit}
                      />
                    </div>
                  </div>
                </Dialog.Panel>
              </TransitionChild>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default EditProcessWheelDrawer;
